import React from "react";
import DataGrid from "./DataGrid/DataGrid.tsx";
import { BrokerReportMappingEnum } from "../../enum/normalization-mapping.enum.ts";

interface BrokerReportDataGridProps {
  policies: any[];
  isLoading: boolean;
}

const BrokerReportDataGrid: React.FC<BrokerReportDataGridProps> = ({
  policies,
  isLoading,
}) => {
  const columns = [
    {
      name: BrokerReportMappingEnum.PolNum,
      header: "№ Полица",
      minWidth: 140,
      type: "string",
    },
    {
      name: BrokerReportMappingEnum.InsComp,
      header: "ЗК",
      minWidth: 150,
      type: "string",
    },
    {
      name: BrokerReportMappingEnum.Insured,
      header: "Застрахован",
      minWidth: 150,
      type: "string",
    },
    {
      name: BrokerReportMappingEnum.PIN,
      header: "ЕГН",
      minWidth: 120,
      type: "number",
    },
    {
      name: BrokerReportMappingEnum.REG_NO,
      header: "Рег. №",
      minWidth: 150,
      type: "string",
    },
    {
      name: BrokerReportMappingEnum.Adres,
      header: "Адрес",
      minWidth: 200,
      type: "string",
    },
    {
      name: BrokerReportMappingEnum.InsType,
      header: "Вид застраховка",
      minWidth: 150,
      type: "string",
    },
    {
      name: BrokerReportMappingEnum.DateBegin,
      header: "От дата",
      minWidth: 120,
      type: "date",
    },
    {
      name: BrokerReportMappingEnum.DateEnd,
      header: "До дата",
      minWidth: 120,
      type: "date",
    },
    {
      name: BrokerReportMappingEnum.Date_VN,
      header: "Дата на вноска",
      minWidth: 120,
      type: "date",
    },
    {
      name: BrokerReportMappingEnum.InsPrem,
      header: "Застрахователна премия",
      minWidth: 150,
      type: "number",
    },
    {
      name: BrokerReportMappingEnum.Commission,
      header: "Комисионна",
      minWidth: 100,
      type: "number",
    },
    {
      name: BrokerReportMappingEnum.TypeContr,
      header: "Тип договор",
      minWidth: 100,
      type: "number",
    },
    {
      name: BrokerReportMappingEnum.GFSum,
      header: "ГФ Сума",
      minWidth: 100,
      type: "number",
    },
    {
      name: BrokerReportMappingEnum.StickerSum,
      header: "Стикер сума",
      minWidth: 100,
      type: "number",
    },
    {
      name: BrokerReportMappingEnum["2PercSum"],
      header: "2% Сума",
      minWidth: 100,
      type: "number",
    },
    {
      name: BrokerReportMappingEnum.SZK,
      header: "СЗК",
      minWidth: 150,
      type: "string",
    },
  ];

  return (
    <DataGrid
      columns={columns}
      dataSource={policies}
      isLoading={isLoading}
      gridTitle="Дневник на Брокера"
      idProperty={BrokerReportMappingEnum.PolNum}
      csvFilename="insurance_contracts_report.csv"
      icon="fa-kit fa-regular-file-circle-question"
      editable={false}
    />
  );
};

export default BrokerReportDataGrid;
